import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Module-level state so every component using this hook stays in sync.
const _listeners = new Set();
let _current = (typeof window !== 'undefined' && localStorage.getItem('portal_lang')) || 'en';

export function setPortalLang(newLang) {
  if (newLang !== 'en' && newLang !== 'es') return;
  _current = newLang;
  try { localStorage.setItem('portal_lang', newLang); } catch {}
  _listeners.forEach((cb) => cb(newLang));
  // If the client is logged in, persist their preference on the server so it
  // follows them across devices.
  const token = typeof window !== 'undefined' && localStorage.getItem('portal_token');
  if (token) {
    axios.post(`${API_URL}/api/portal/me/language?lang=${newLang}`, null, {
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }
}

export function usePortalLang() {
  const [lang, setLangState] = useState(_current);
  useEffect(() => {
    const cb = (l) => setLangState(l);
    _listeners.add(cb);
    return () => _listeners.delete(cb);
  }, []);
  const t = (en, es) => (lang === 'es' ? es : en);
  return { lang, setLang: setPortalLang, t };
}
